import { render, staticRenderFns } from "./org_wrong_set.vue?vue&type=template&id=5a4cc8fc&scoped=true"
import script from "./org_wrong_set.vue?vue&type=script&lang=js"
export * from "./org_wrong_set.vue?vue&type=script&lang=js"
import style0 from "./org_wrong_set.vue?vue&type=style&index=0&id=5a4cc8fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4cc8fc",
  null
  
)

export default component.exports